import { 
  LayoutDashboard, 
  Users, 
  Building2, 
  Megaphone,
  BarChart3,
  Briefcase,
  Package,
  CheckSquare,
  TrendingUp,
  Radar,
} from 'lucide-react';
import { AppLayout } from '../../../shared/components/layout/AppLayout';
import type { NavGroup } from '../../../shared/components/layout/AppLayout';
import { Badge } from '../../../shared/components/ui/Badge';
import { SidebarCallout } from '../../../shared/components/layout/SidebarCallout';
import { useOrganizationContext } from '../../../shared/contexts/OrganizationContext';
import { useActions } from '../../../domains/action-center/hooks/useActions';

function AdminHeader() {
  return (
    <div className="flex items-center justify-center h-16 gap-2">
      <img 
        src="https://psezrfpnqxfxupfutlnq.supabase.co/storage/v1/object/public/assets/videreo_logo.png"
        alt="Videreo Logo" 
        className="h-8 w-auto" 
      />
      <Badge variant="destructive" className="text-xs">
        Admin
      </Badge>
    </div>
  );
}

export function AdminLayout({ children }: { children?: React.ReactNode }) {
  const { userContext } = useOrganizationContext();
  const { actionCount } = useActions({
    organizationId: null,
    profileId: userContext?.profileId,
    role: 'org',
    countOnly: true,
  });
  const openTasksCount = actionCount;
  const adminNavGroups: NavGroup[] = [
    {
      items: [
        { title: 'Dashboard', url: '/admin/dashboard', icon: LayoutDashboard },
        { title: 'Action Center', url: '/admin/action-center', icon: CheckSquare, badge: openTasksCount > 0 ? openTasksCount : undefined },
      ],
    },
    {
      title: 'Operations',
      items: [
        { title: 'Campaigns', url: '/admin/campaigns', icon: Megaphone },
        { title: 'Creators', url: '/admin/creators', icon: Users },
        { title: 'Creator Tools', url: '/admin/creator-tools', icon: Package },
        { title: 'Campaign Reports', url: '/admin/reports', icon: BarChart3 },
        { title: 'Company Stats', url: '/admin/company-stats', icon: TrendingUp },
        { title: 'Creator opportunities', url: '/admin/creator-opportunities', icon: Radar },
      ],
    },
    {
      title: 'Management',
      items: [
        { title: 'Organizations', url: '/admin/organizations', icon: Building2 },
        { title: 'Clients', url: '/admin/clients', icon: Briefcase },
      ],
    },
    {
      title: 'Administration',
      items: [
        { title: 'Users', url: '/admin/users', icon: Users },
      ],
    },
  ];

  return (
    <AppLayout
      headerSlot={<AdminHeader />}
      navGroups={adminNavGroups}
      mode="admin"
      preFooterSlot={<SidebarCallout showWhatsApp={false} />}
      siteHeaderTitle="Admin Panel"
    >
      {children}
    </AppLayout>
  );
}

export default AdminLayout;
